import { MenuItem } from "../components/MenuItem";

const adminItem = (translate: (key: string) => string): MenuItem => ({
  id: '17',
  title: translate('menuItems.admin'),
  icon: 'lock',
  screen: 'Admin',
})

export const getMenuItems = (
  translate: (key: string) => string,
  options: { isSuperAdmin?: boolean } = {},
): MenuItem[] => [
  {
    id: '16',
    title: translate('menuItems.events'),
    icon: 'calendarStar',
    screen: 'Events',
  },
  ...(options.isSuperAdmin ? [adminItem(translate)] : []),
  {
    id: '0',
    title: translate('menuItems.importContacts'),
    icon: 'userPlus',
    screen: 'ImportContacts',
    showDivider: false,
  },
  {
    id: '12',
    title: translate('menuItems.classifyProfiles'),
    icon: 'classify',
    screen: 'ClassifyContacts',
    showDivider: false,
  },
  {
    id: '13',
    title: translate('menuItems.mergeProfiles'),
    icon: 'merge',
    screen: 'MergeContacts',
    showDivider: true,
  },
  {
    id: '1',
    title: translate('menuItems.maps'),
    icon: 'map',
    screen: 'Map',
  },
  {
    id: '14',
    title: translate('menuItems.graph'),
    icon: 'people',
    screen: 'Graph',
  },
  {
    id: '15',
    title: translate('menuItems.nearby'),
    icon: 'mapPin',
    screen: 'Nearby',
  },
  {
    id: '2',
    title: translate('menuItems.notes'),
    icon: 'note',
    screen: 'Notes',
  },
  {
    id: '3',
    title: translate('menuItems.categories'),
    icon: 'category',
    screen: 'Categories',
  },
  {
    id: '4',
    title: translate('menuItems.hashtags'),
    icon: 'htag',
    screen: 'Hashtags',
  },

  {
    id: '5',
    title: translate('menuItems.relationalColors'),
    icon: 'people',
    screen: 'RelationalColors',
    showDivider: true,
  },
  {
    id: '6',
    title: translate('menuItems.appointments'),
    icon: 'calendar',
    screen: 'Calendar',
  },
  {
    id: '7',
    title: translate('menuItems.birthdays'),
    icon: 'gift',
    screen: 'Birthdays',
  },
  {
    id: '8',
    title: translate('menuItems.keepContact'),
    icon: 'keepContact',
    screen: 'KeepContact',
  },
  {
    id: '9',
    title: translate('menuItems.scheduledMessages'),
    icon: 'clock',
    screen: 'ScheduledMessages',
    showDivider: true,
  },
  {
    id: '10',
    title: translate('menuItems.qrCode'),
    icon: 'qrCode',
    screen: 'QRCode',
  },
  {
    id: '18',
    title: translate('settings.subscription'),
    icon: 'creditCard',
    screen: 'Subscription',
  },
  {
    id: '11',
    title: translate('menuItems.settings'),
    icon: 'settings',
    screen: 'Settings',
    showDivider: true,
  },
]

export const getMenuItemsWeb = (
  translate: (key: string) => string,
  options: { isSuperAdmin?: boolean } = {},
): MenuItem[] => [
  {
    id: '16',
    title: translate('menuItems.events'),
    icon: 'calendarStar',
    screen: 'Events',
  },
  ...(options.isSuperAdmin ? [adminItem(translate)] : []),
  {
    id: '0',
    title: translate('menuItems.importContacts'),
    icon: 'userPlus',
    screen: 'ImportContacts',
    showDivider: false,
  },
  {
    id: '12',
    title: translate('menuItems.classifyProfiles'),
    icon: 'classify',
    screen: 'ClassifyContacts',
    showDivider: false,
  },
  {
    id: '13',
    title: translate('menuItems.mergeProfiles'),
    icon: 'merge',
    screen: 'MergeContacts',
    showDivider: true,
  },
  {
    id: '1',
    title: translate('menuItems.maps'),
    icon: 'map',
    screen: 'Map',
  },
  {
    id: '14',
    title: translate('menuItems.graph'),
    icon: 'people',
    screen: 'Graph',
  },
  {
    id: '15',
    title: translate('menuItems.nearby'),
    icon: 'mapPin',
    screen: 'Nearby',
  },
  {
    id: '2',
    title: translate('menuItems.notes'),
    icon: 'note',
    screen: 'Notes',
  },
  {
    id: '3',
    title: translate('menuItems.categories'),
    icon: 'category',
    screen: 'Categories',
  },
  {
    id: '4',
    title: translate('menuItems.hashtags'),
    icon: 'htag',
    screen: 'Hashtags',
  },

  {
    id: '5',
    title: translate('menuItems.relationalColors'),
    icon: 'people',
    screen: 'RelationalColors',
    showDivider: true,
  },
  {
    id: '6',
    title: translate('menuItems.appointments'),
    icon: 'calendar',
    screen: 'Calendar',
  },
  {
    id: '7',
    title: translate('menuItems.birthdays'),
    icon: 'gift',
    screen: 'Birthdays',
  },
  {
    id: '8',
    title: translate('menuItems.keepContact'),
    icon: 'keepContact',
    screen: 'KeepContact',
  },
  {
    id: '9',
    title: translate('menuItems.scheduledMessages'),
    icon: 'clock',
    screen: 'ScheduledMessages',
    showDivider: true,
  },
]
